module.exports = __webpack_public_path__ + "static/img/wechat.43b2e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/wechat.png
// module id = Ja7t
// module chunks = 225